import { useTranslation } from 'react-i18next';
import { createColumnHelper } from '@tanstack/react-table';

import ArrowDownUpIcon from '@/component-library/primitives/Icons/ArrowDownUpIcon/ArrowDownUpIcon';
import { Domain } from '@/models/Domain';

export const useDomainsTable = () => {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<Domain>();

  const columns = [
    columnHelper.accessor('domainName', {
      header: () => (
        <div className="flex flex-row items-center gap-1">
          <span>{t('DomainsPage.domainNameColumn')}</span>
          <span className="cursor-pointer">
            <ArrowDownUpIcon />
          </span>
        </div>
      ),
      cell: (info) => <span className="block truncate">{info.renderValue()}</span>,
    }),
    columnHelper.accessor('status', {
      header: () => (
        <div className="flex flex-row items-center gap-1">
          <span>{t('DomainsPage.status')}</span>
        </div>
      ),
      cell: (info) => <span className="block truncate">{info.renderValue()}</span>,
    }),
    columnHelper.accessor('createdAt', {
      header: () => <div>{t('DomainsPage.createdAtColumn')}</div>,
      cell: (info) => (
        <div className="flex flex-col">
          <span>
            {new Date(info.renderValue() as string).toLocaleDateString('en-us', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })}
          </span>
          <span className="text-sm">
            {new Date(info.renderValue() as string).toLocaleTimeString('en-us', {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </span>
        </div>
      ),
    }),
    columnHelper.accessor('createdByName', {
      header: () => <div>{t('DomainsPage.createdByColumn')}</div>,
      cell: (info) => <div className="truncate max-w-[12rem]">{info.renderValue()}</div>,
    }),
    columnHelper.accessor('lastModifiedAt', {
      header: () => <div>{t('DomainsPage.lastModifiedAtColumn')}</div>,
      cell: (info) => (
        <div className="flex flex-col">
          <span>
            {new Date(info.renderValue() as string).toLocaleDateString('en-us', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })}
          </span>
          <span className="text-sm">
            {new Date(info.renderValue() as string).toLocaleTimeString('en-us', {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </span>
        </div>
      ),
    }),
    columnHelper.accessor('lastModifiedByName', {
      header: () => <div>{t('DomainsPage.lastModifiedByColumn')}</div>,
      cell: (info) => <div className="truncate max-w-[12rem]">{info.renderValue()}</div>,
    }),
  ];

  return { columns };
};
